export const worker = new Worker("/worker.js")
